module.exports = __webpack_public_path__ + "static/img/sellIcon.b2375b3f.svg";